import { Link, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { BrandLogo } from '@/components/BrandLogo';

// Shared header + footer for public marketing/content pages.
// The footer provides site-wide internal linking (important for crawlability).
export const MarketingLayout = ({ children }) => {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="sticky top-0 z-40 border-b border-border/60 bg-background/80 backdrop-blur">
        <div className="max-w-6xl mx-auto flex items-center justify-between px-6 h-16">
          <Link to="/" data-testid="marketing-logo-link" className="flex items-center">
            <BrandLogo width={140} />
          </Link>
          <nav className="flex items-center gap-4 text-sm">
            <Link to="/guides" className="hidden sm:inline text-muted-foreground hover:text-foreground transition-colors">Guides</Link>
            <Link to="/pricing" className="hidden sm:inline text-muted-foreground hover:text-foreground transition-colors">Pricing</Link>
            <Button size="sm" data-testid="marketing-cta-button" onClick={() => navigate('/signup')}>
              Start Free Trial
            </Button>
          </nav>
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-border/60 mt-16">
        <div className="max-w-6xl mx-auto px-6 py-10 grid gap-8 sm:grid-cols-4 text-sm">
          <div className="sm:col-span-1">
            <BrandLogo width={130} />
            <p className="mt-3 text-muted-foreground text-xs leading-relaxed">
              AI-powered vendor compliance automation for property managers.
            </p>
          </div>
          <div>
            <p className="font-semibold mb-3">Product</p>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/" className="hover:text-foreground">Home</Link></li>
              <li><Link to="/pricing" className="hover:text-foreground">Pricing</Link></li>
              <li><Link to="/demo" className="hover:text-foreground">Watch Demo</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-semibold mb-3">Resources</p>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/guides" className="hover:text-foreground">Guides</Link></li>
              <li><Link to="/tools/coi-requirement-builder" className="hover:text-foreground">COI Requirement Builder</Link></li>
              <li><Link to="/guides/track-coi-expiration-across-portfolio" className="hover:text-foreground">Track COI Expiration</Link></li>
              <li><Link to="/guides/vendor-compliance-checklist-property-managers" className="hover:text-foreground">Compliance Checklist</Link></li>
              <li><Link to="/compare/vendorsuite-vs-netvendor" className="hover:text-foreground">VendorSuite vs NetVendor</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-semibold mb-3">Company</p>
            <ul className="space-y-2 text-muted-foreground">
              <li><Link to="/terms" className="hover:text-foreground">Terms</Link></li>
              <li><Link to="/privacy" className="hover:text-foreground">Privacy</Link></li>
              <li><Link to="/login" className="hover:text-foreground">Log In</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-border/60 py-4 text-center text-xs text-muted-foreground">
          © {new Date().getFullYear()} VendorSuite. All rights reserved.
        </div>
      </footer>
    </div>
  );
};

export default MarketingLayout;
